var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    { staticClass: "product-card__wrapper", attrs: { href: _vm.product.link } },
    [
      _c(
        "header",
        { staticClass: "product-card__header" },
        [
          _c("img", {
            staticClass: "product-card__image",
            attrs: { src: _vm.image, alt: "" },
          }),
          _vm._v(" "),
          _vm.product.badge
            ? _c("badge", { attrs: { badge: _vm.product.badge_settings } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "product-card__body" }, [
        _c("h6", { staticClass: "product-card__title" }, [
          _vm._v(_vm._s(_vm.product.title) + " "),
          _vm.showSupplier && _vm.supplier
            ? _c("span", [_vm._v("| " + _vm._s(_vm.supplier.name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("p", { domProps: { innerHTML: _vm._s(_vm.product.price_html) } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Product.vue